import Typography from '@material-ui/core/Typography'

import { getTranslate } from '../../localization'
import { PaymentSettlementEvidence } from '../../types/paymentFollowUps'

function bookingEvidenceLabel(evidence: PaymentSettlementEvidence): string {
  if (evidence.crsStatus === 'Confirmed' && evidence.pmsStatus === 'Confirmed')
    return getTranslate('Booking confirmed')
  if (evidence.crsStatus === 'Cancelled' && evidence.pmsStatus === 'Cancelled')
    return getTranslate('Booking cancelled')
  if (evidence.crsStatus === 'Confirmed' || evidence.pmsStatus === 'Confirmed')
    return getTranslate('Booking outcome needs verification')
  if (
    [
      'ReservationExpired',
      'ReservationFailed',
      'ConfirmationFailed',
      'PrimitiveExpired'
    ].includes(evidence.crsStatus ?? '')
  )
    return getTranslate('Booking failed or expired')
  return getTranslate('Booking outcome needs verification')
}

export default function EvidenceSummary({
  evidence
}: {
  evidence?: PaymentSettlementEvidence | null
}) {
  if (!evidence) return null
  const refund =
    evidence.refundState === 'Confirmed'
      ? getTranslate('Refund confirmed')
      : evidence.refundState === 'Unsupported'
      ? getTranslate('Automated refund unavailable')
      : getTranslate('Refund outcome not confirmed')
  const wallet =
    evidence.walletCreditState === 'Confirmed'
      ? getTranslate('Wallet credit confirmed')
      : getTranslate('Wallet credit not confirmed')
  return (
    <div>
      {evidence.refundState && (
        <Typography variant="caption" component="p">
          {refund}
        </Typography>
      )}
      {evidence.walletCreditState && (
        <Typography variant="caption" component="p">
          {wallet}
        </Typography>
      )}
      {evidence.crsStatus && (
        <Typography variant="caption" component="p">
          {bookingEvidenceLabel(evidence)}
        </Typography>
      )}
    </div>
  )
}
